<template>
  <div class="z1">
    <footer class="pt-4">
      <div class="container-fluid">
        
        
      </div>
    </footer>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

